<ng-template [ngIf]="baggageForm !== '1'">
  <form [formGroup]="baggageForm" (submit)="saveBaggageDetails()">
    <div class="container-fluid card p-2 mt-4">
      <div class="col-sm-12 mt-2 p-4">
        <div id="servAddlistpn" class="container-fluid mt-2 commonFormsCss QProduct">
          <h5>
            <ng-template [ngIf]="serviceType !== 'CARB'">
              Add Services :
              {{ addBaggageScreen.passengerName }}
            </ng-template>
            <ng-template [ngIf]="serviceType === 'CARB'"> Add Climate Product : {{ addBaggageScreen.passengerName }}</ng-template>
          </h5>
          <div class="mt-20" formArrayName="boundBaggageList">
            <div class="mt-30 boundBaggageList" *ngFor="let addBaggageDetail of inp_arr('boundBaggageList').controls; let i = index" [formGroupName]="i">
              <ng-template [ngIf]="addBaggageScreen.boundBaggageList[i].baggageDropdown.length > 1">
                <h4>
                  {{ dropdownLabel }}
                  <strong
                    ><b>{{ addBaggageScreen.boundBaggageList[i].flightNumber }}</b></strong
                  >
                </h4>
                <div></div>
                <div class="mt-10" style="position: relative">
                  <img [src]="dropdownImgSrc" class="selectIcon" />
                  <select
                    *ngIf="isClimateProduct"
                    formControlName="selectedBaggage"
                    class="form-control fa-select"
                    #selectedBaggage
                    (change)="selectChangeHandler($event, addBaggageScreen.boundBaggageList[i].baggageDropdown, i)"
                  >
                    <option
                      *ngFor="let dropDownItem of addBaggageScreen.boundBaggageList[i].baggageDropdown; let dropdownIndex = index"
                      value="{{ dropdownIndex }}"
                      class="fa-align-left ui-meal"
                    >
                      <div>
                        {{ dropDownItem.baggageName }}
                        <ng-template [ngIf]="dropDownItem.flightNumber"> | {{ dropDownItem.flightNumber }} | {{ dropDownItem.price }} {{ dropDownItem.currency }} </ng-template>
                      </div>
                    </option>
                  </select>
                  <select
                    *ngIf="!isClimateProduct"
                    formControlName="selectedBaggage"
                    class="form-control fa-select"
                    #selectedBaggage
                  >
                    <option
                      *ngFor="let dropDownItem of addBaggageScreen.boundBaggageList[i].baggageDropdown; let dropdownIndex = index"
                      value="{{ dropdownIndex }}"
                      class="fa-align-left ui-meal"
                    >
                      <div>
                        {{ dropDownItem.baggageName }}
                        <ng-template [ngIf]="dropDownItem.flightNumber"> | {{ dropDownItem.flightNumber }} | {{ dropDownItem.price }} {{ dropDownItem.currency }} </ng-template>
                      </div>
                    </option>
                  </select>
                  <div *ngFor="let climateDescription of climateDescriptionMap | keyvalue">
                    <ng-template [ngIf]="climateDescriptionMap && serviceType === 'CARB' && climateDescription.key === i">
                      <div class="width80 mt-3">{{ climateDescription.value[0].TEXT[0] }}</div>
                      <div class="mt-1">CO2 : {{ climateDescription.value[1].TEXT[0] }}</div>
                    </ng-template>
                  </div>
                </div>
              </ng-template>
            </div>
            <div style="right: 100px; margin-top: 40px">
              <button type="button" class="ba-btn ba-btn-sm-vthin" role="button" (click)="servHide(1)"><i class="fa fa-times-circle"></i> Cancel</button>
              <button type="submit" class="ba-btn ba-btn-sm-vthin float-right" role="button"><i class="fa fa-shopping-cart"></i> Save Service</button>
            </div>
          </div>
        </div>
      </div>
      <div class="float-right" style="position: absolute; top: 20px; right: 20px">
        <p href="" (click)="servHide(2)" class="ba-btn ba-btn-sq-sm" role="button"><i class="fa fa-times"></i></p>
      </div>
    </div>
  </form>
</ng-template>
